"use client";

import React from "react";
import { Button, Input } from "@west-tennessee-consulting/ui";
import { Loader2, AlertCircle } from "lucide-react";

interface SearchStepProps {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onSearch: () => void;
  loading: boolean;
  error: string | null;
}

export function SearchStep({
  searchQuery,
  onSearchQueryChange,
  onSearch,
  loading,
  error,
}: SearchStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-2">Company Name</label>
        <Input
          placeholder="Enter company name to search..."
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSearch();
          }}
          disabled={loading}
        />
      </div>

      {error && (
        <div className="flex items-center gap-2 p-3 bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800 rounded text-red-700 dark:text-red-300 text-sm">
          <AlertCircle className="w-4 h-4" />
          {error}
        </div>
      )}

      <div className="flex gap-2">
        <Button
          onClick={onSearch}
          disabled={loading || !searchQuery.trim()}
          className="flex-1"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Searching...
            </>
          ) : (
            "Search"
          )}
        </Button>
      </div>
    </div>
  );
}
